export enum VoucherDuration {
    MONTH = "P1M",
    MONTHS3 = "P3M",
    MONTHS6 = "P6M",
    YEAR = "P1Y",
    YEARS2 = "P2Y",
    YEARS3 = "P3Y",
}